import React, { FC, ReactNode } from "react";
import { MainStyled, WrapperStyled } from "./Template.styles";

interface ChildrenProps {
  children: ReactNode;
}

const Main: FC<ChildrenProps> = (props) => (
  <MainStyled>{props.children}</MainStyled>
);

const Wrapper: FC<ChildrenProps> = (props) => (
  <WrapperStyled>{props.children}</WrapperStyled>
);

export default {
  Main,
  Wrapper,
};
